<template lang="pug">
.container-restricao
    .restricoes(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
                |
                | {{ restricao.nome }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.fase') }}:
                |
                | {{ restricao.fase }}
                br
                span(v-if="restricao.processoFase")
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.processoFase') }}:
                    |
                    | {{ restricao.processoFase }}
                    span &nbsp;
                        el-tooltip(effect='light', placement='right')
                            span(slot='content')
                                div.tooltip-terra-indigena-content
                                    h3 {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.processoFase') }}
                                    p(v-if='restricao.processoFase == "Homologada"')
                                        b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.homologadas') }}
                                        span  - {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.processoFaseHomologada') }}
                                    p(v-else)
                                        b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.naoHomologadas') }}
                                        span  - {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.processoFaseNaoHomologada') }}

                                    p.align-left {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.fonte') }}: {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.processoFaseFonte') }}
                            span
                                i.information-card.mdi.mdi-information-outline.criterio-fora-regiao.icone

                    br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.etnia') }}:
                |
                | {{ restricao.etnia }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigo') }}:
                |
                | {{ restricao.codigo_ti }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao.areaHa) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.unidade') }}:
                |
                | {{ restricao.unidade_administrativa }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.modalidade') }}:
                |
                | {{ restricao.modalidade }}
                Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                )
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'terra-indigena',

    data() {
        return {};
    },

    components: {
        Criticidade,
        BaseButton
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>

<style>
    .tooltip-terra-indigena-content{
        width: 250px;
        color: var(--primary);
    }

    .tooltip-terra-indigena-content h3 {
        font-weight: 400;
    }

    .tooltip-terra-indigena-content p {
        margin-top: 10px;
        text-align: justify;
    }

    .tooltip-terra-indigena-content .tooltip-terra-indigena-content p {
        font-weight: 600;
    }

    .tooltip-terra-indigena-content .align-left{
        text-align: left;
    }
</style>
